/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Represents a related cluster in an Aurora Global Database. For primary clusters, this shows connected secondary clusters. For secondary clusters, this shows the primary cluster. 
*/
export class RelatedGlobalDbCluster {
  /**
  * Eon resource ID.
  */
  'id': string;
  /**
  * Cluster name/identifier.
  */
  'name': string;
  /**
  * AWS region where the cluster is located.
  */
  'region': string;
  /**
  * Role in the Global Database (primary or secondary).
  */
  'role': string;
  /**
  * AWS account ID.
  */
  'providerAccountId': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "role",
      "baseName": "role",
      "type": "string",
      "format": ""
    },
    {
      "name": "providerAccountId",
      "baseName": "providerAccountId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RelatedGlobalDbCluster.attributeTypeMap;
  }

  public constructor() {
  }
}

